// 基类
export default abstract class Filter {
  name: string;
  key: string;
  visible: boolean;

  constructor(name: string, key: string, visible?: boolean) {
    this.name = name;
    this.key = key;
    this.visible = visible === undefined ? true : visible;
  }

  // 抽象方法
  abstract getValueString(): string;
  abstract putValue(value: string): void;
  abstract reset(): void;
  abstract isEmpty(): boolean;
}

// 文本过滤器
export class TextFilter extends Filter {
  private value: string = '';

  constructor(name: string, key: string, visible?: boolean) {
    super(name, key, visible);
  }

  getValueString(): string {
    return this.value;
  }

  putValue(value: string) {
    this.value = value || '';
  }

  reset() {
    this.value = '';
  }

  isEmpty(): boolean {
    return !this.value.trim();
  }
}

// 选择过滤器
export class SelectFilter extends Filter {
  private selectedValue: string = '';

  constructor(name: string, key: string, visible?: boolean) {
    super(name, key, visible);
  }

  getValueString(): string {
    return this.selectedValue;
  }

  putValue(value: string) {
    this.selectedValue = value || '';
  }

  reset() {
    this.selectedValue = '';
  }

  isEmpty(): boolean {
    return !this.selectedValue;
  }
}

// 导出基类（如果需要）
export { Filter };